// globalExtensions.js
/* eslint-disable no-extend-native */
String.prototype.isNullOrEmpty = function () {
  return this == null || this.trim() === '';
};
/* eslint-enable no-extend-native */
